// src/components/autopilot/ProgressTracker.js
import React from 'react';
import { Box, Stepper, Step, StepLabel, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

const steps = [
  'Enter Intent',
  'Validate ICP',
  'Search Progress',
  'Review Results',
  'Create List'
];

function ProgressTracker({ currentStep }) {
  return (
    <Box sx={{ width: '100%', mb: 4 }}>
      <Stepper activeStep={currentStep - 1} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel
              StepIconComponent={({ active, completed }) => (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    bgcolor: completed || active ? '#1BE885' : '#e0e0e0',
                    color: completed || active ? '#fff' : '#666',
                  }}
                >
                  {completed ? (
                    <CheckCircleIcon />
                  ) : (
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      {index + 1}
                    </Typography>
                  )}
                </Box>
              )}
            >
              <Typography variant="body2" sx={{ fontWeight: currentStep === index + 1 ? 600 : 400 }}>
                {label}
              </Typography>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}

export default ProgressTracker;
